const initialState = null;

export default (state = initialState, {type, payload}) => {
	switch (type) {
		case "SIGN_OUT":
			return initialState;
		case "ADD_PROFESSIONS":
			return payload;
		case "REMOVE_PROFESSIONS":
			return [];
		default:
			return state;
	}
};
